import React from "react";
import { Link } from "react-router-dom";
import { HrefCTA } from "../Utils";
import "./index.css";

function ReadyGo () {
  return (    
    <div className="bg-gray py-3">
      <div className="container text-center">
        <h3 className="section__header section__header--medium pb-0 mb-0">Ready to start growing?</h3>
        <p className="section__header section__header--light pb-2">Learn to grow early, rapidly and securely.</p>
        <div className="d-flex flex--center py-3">                    
          <Link to="/" className="btn btn--green">Get started</Link>
        </div>            
      </div>
    </div>
  );
}

function JoinGERS () {
  return (
    <div className="w-100 my-0 join__action bg-join py-3 text-center">
      <h2 className="w-100 section__header section__footer--medium my-0 pt-0 pb-3 text-white">Join Global GERS to grow your ventures early, rapidly and securely</h2>
      <HrefCTA href="/joinus" target="_blank" rel="noreferrer noopener">Join us!</HrefCTA>
    </div>
  );
}


export { ReadyGo, JoinGERS }



// WEBPACK FOOTER //
// ./src/Components/CallAction/index.js